function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnexLogoText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "121mm",
    height: "64mm",
    viewBox: "0 0 121 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: ".264583px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m132.838 129.02 18.163-19.725-6.616-8.6 8.18 6.916 4.21-2.466-4.09 4.09.962 1.022-20.809 18.764 23.936-23.876-3.135 5.112",
    transform: "rotate(90 163.699 37.519)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: ".264583px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M113.317 16.121 98.956 32.046l6.615 8.6-8.179-6.916-4.21 2.466 4.09-4.09-.962-1.022 17.007-14.963-20.135 20.075 3.135-5.112M111.896 57.981 91.57 39.337l-8.6 6.616 6.916-8.18-2.466-4.209 4.09 4.09 1.022-.963 19.365 21.29L87.42 33.564l5.112 3.135M70.59 47.997l14.19-15.924-6.615-8.6 8.18 6.916 4.21-2.466-4.09 4.09.962 1.022-16.838 14.962 19.965-20.074-3.135 5.112"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#fff",
      strokeOpacity: 1
    },
    transform: "matrix(-.09722 -.05486 .04086 .14534 82.106 12.517)",
    d: "m78.435 127.296-13.194-16.17 20.601-3.341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 0.008,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M99.697 19.282c.458-.607.833-1.107.833-1.11 0-.005-.011-.012-.026-.017-.027-.01-.031-.008-.187.064a2576.692 2576.692 0 0 0-3.164 1.481l-.043.02.865.33c.476.182.871.332.878.333.008.001.28-.355.844-1.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 0.000454604,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m104.887 40.128-1.101-.834c-.389-.294-.423-.324-.412-.355l.324-.845c.171-.446.316-.82.321-.83.01-.015.426.864 1.47 3.099.093.2.118.281.084.278-.006 0-.314-.231-.686-.513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 0.000909212,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M84.677 45.272c.905-.425 1.635-.78 1.624-.79a35.87 35.87 0 0 0-1.65-.629c-.03 0-1.634 2.093-1.659 2.166-.006.016.001.028.015.027.014-.001.766-.35 1.67-.774z"
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "ENE",
    style: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "22.21899986px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.231447
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.348 38.475q.222 0 .334.133.133.111.133.333v1.2q0 .222-.133.356-.112.11-.334.11H7.972q-.222 0-.356.134-.11.111-.11.334v3.71q0 .222.11.356.134.11.356.11h5.555q.222 0 .333.134.133.111.133.333v1.2q0 .222-.133.356-.111.11-.333.11H7.972q-.222 0-.356.134-.11.111-.11.333v4.31q0 .223.11.356.134.111.356.111h9.376q.222 0 .334.134.133.11.133.333v1.2q0 .222-.133.355-.112.111-.334.111H5.55q-.222 0-.356-.11-.11-.134-.11-.356V38.94q0-.222.11-.333.134-.133.356-.133zM31.835 50.207q.156.222.333.222.111 0 .178-.09.067-.11.067-.31V38.94q0-.222.11-.333.134-.133.356-.133h1.378q.222 0 .333.133.134.111.134.333v15.354q0 .222-.134.355-.11.111-.333.111h-1.555q-.356 0-.556-.288l-8.288-11.465q-.155-.223-.31-.223-.112 0-.2.111-.067.112-.067.312v11.087q0 .222-.134.355-.11.111-.333.111h-1.4q-.222 0-.355-.11-.111-.134-.111-.356V38.94q0-.222.11-.333.134-.133.356-.133h1.622q.356 0 .556.289zM50.943 38.475q.223 0 .334.133.133.111.133.333v1.2q0 .222-.133.356-.111.11-.334.11h-9.376q-.222 0-.356.134-.11.111-.11.334v3.71q0 .222.11.356.134.11.356.11h5.555q.222 0 .333.134.133.111.133.333v1.2q0 .222-.133.356-.111.11-.333.11h-5.555q-.222 0-.356.134-.11.111-.11.333v4.31q0 .223.11.356.134.111.356.111h9.376q.223 0 .334.134.133.11.133.333v1.2q0 .222-.133.355-.111.111-.334.111H39.145q-.222 0-.355-.11-.112-.134-.112-.356V38.94q0-.222.112-.333.133-.133.355-.133z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "22.21899986px",
      fontFamily: "'Shippori Antique B1'",
      InkscapeFontSpecification: "'Shippori Antique B1'",
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 0.231447
    },
    transform: "scale(1.46759 .6814)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnexLogoText);
export default __webpack_public_path__ + "static/media/enex-logo-text.c69e540efe93d643fd222fece93b954a.svg";
export { ForwardRef as ReactComponent };